<template>
    <div class="join-frame">
        <div style="padding-top: 80px"></div>
        <banner></banner>
        <div class="join-main">
            <board></board>
            <introduce></introduce>
            <develop></develop>
            <stockholder></stockholder>
            <distribute></distribute>
            <manage></manage>
            <honour></honour>
            <culture></culture>
        </div>
    </div>
</template>

<script>
    import banner from './components/banner'
    import board from './components/board'
    import introduce from './components/introduce'
    import develop from './components/develop'
    import stockholder from './components/stockholder'
    import distribute from  './components/distribute'
    import manage from  './components/manage'
    import honour from '../index/components/honour'
    import culture from './components/culture'
    export default {
        name: "join",
        components: {
            banner,
            board,
            introduce,
            develop,
            stockholder,
            distribute,
            culture,
            honour,
            manage
        },
    }
</script>

<style scoped lang="scss">
    .join-frame {
        min-width: 1200px;
        min-height: 400px;
        overflow: hidden;
        .join-main{
            width: 1200px;
            position: relative;
            margin: 0 auto;
        }
    }
</style>
